import React, { useEffect } from "react";

import { motion, animate } from "motion/react";

export const defaultEmojis = [
  "💖",
  "💖",
  "💖",
  "💖",
  "💖",
  "💖",
  "😀",
  "🎉",
  "💖",
  "🌟",
  "🔥",
  "💎",
  "🍕",
  "🎵",
  "💖",
  "💖",
  "💖",
  "💖",
  "💖",
  "💖",
  "😀",
  "🎉",
  "💖",
  "🌟",
  "🔥",
  "💎",
  "🍕",
  "🎵",
];

export const questionEmojis = [
  "❓",
  "🎧",
  "🎤",
  "😀",
  "🎉",
  "🎵",
  "❓",
  "🎧",
  "🎤",
  "😀",
  "🎉",
  "🎵",
  "❓",
  "🎧",
  "🎤",
  "😀",
  "🎉",
  "🎵",
  "❓",
  "🎧",
  "🎤",
  "😀",
  "🎉",
  "🎵",
  "❓",
  "🎧",
  "🎤",
  "😀",
  "🎉",
  "🎵",
  "❓",
  "🎧",
  "🎤",
  "😀",
  "🎉",
  "🎵",
];

export const EmojiWave = ({ emojis, next }) => {
  useEffect(() => {
    //Implementing the setInterval method
    const interval = setTimeout(() => {
      if (next) {
        next();
      }
    }, 2000);

    //Clearing the interval
    return () => clearTimeout(interval);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {emojis.map((emoji, index) => (
        <motion.div
          key={index}
          style={{
            position: "absolute",
            fontSize: `${Math.floor(Math.random() * 6)}em`,
            left: `${Math.random() * 100}%`, // Random horizontal position
          }}
          initial={{ y: "100vh", bottom: "-100vh" }}
          animate={{ y: "0px", bottom: "100vh" }}
          transition={{
            duration: emojis.length * 0.1, // Animate in 1 second
            type: "spring",
            bounce: 0.25,
            delay: index * 0.1, // Stagger the emojis for a wave effect
          }}
        >
          {emoji}
        </motion.div>
      ))}
    </div>
  );
};

export default EmojiWave;
